import { OmyConst } from "../../OmyConst";
import OButton from "./OButton";

export default class OCheckBox extends OButton {
    constructor(outTexture, atlas = null, overTexture = null, downTexture = null, blockTexture = null, json = null) {
        super(outTexture, atlas, overTexture, downTexture, blockTexture, json);

        this._gdConf = json;
        this._oType = OmyConst.OMY_CHECK_BOX;
        this._isChecking = true;

        if (json) this.addOtherStates(json);
    }

    /** @public */
    addOtherStates(states) {
        this._states = states || {};
        this._states["default"] = {
            out: this._outTexture,
            over: this._overTexture,
            down: this._downTexture,
            block: this._blockrTexture
        };

        this._checkState();
    }

    destroy(options) {
        this._gdConf = null;
        this._states = null;
        return super.destroy(options);
    }

    _onUpHandler() {
        this._isChecking = !this._isChecking;
        this._checkState();
        super._onUpHandler();
    }

    _checkState() {
        if (this._isChecking) this._changeState("active");
        else this._changeState("noActive");
    }

    _changeState(stateKey) {
        let state = this._states[stateKey] || this._states["default"];
        this.changeTextures(state["out"], state["over"], state["down"], state["block"]);
    }

    set isChecking(value) {
        this._isChecking = value;
        this._checkState();
    }

    get isChecking() {
        return this._isChecking;
    }
}
